export default __webpack_public_path__ + "static/media/ESSC16LSAP02.3c932a79.mp4";